import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { CourseCardContext } from 'contexts/CourseCardContext'
import { postCourseLog } from 'services/api/course_advertisment'
import StatusChipApplication from './StatusChipApplication'
import Bugsnag from '@bugsnag/js'

const CourseCard = (props) => {
  const navigate = useNavigate()
  const { courseID, setCourseID, setSelectedCourse } = useContext(CourseCardContext)

  async function showCourseDetail() {
    if (window.innerWidth >= 1024) {
      setCourseID(props.item.id)
      setSelectedCourse(props.item)
      if (!('nex_edu_course_id' in props.item)) {
        try {
          const data = { nex_edu_course_id: props.item.id }
          await postCourseLog(data)
        } catch (e) {
          Bugsnag.notify(e)
        }
      }
    } else {
      if ('nex_edu_course_id' in props.item) {
        navigate(`/course-application/${props.item.id}`)
      } else {
        navigate(`/courses/${props.item.id}`)
      }
    }
  }
  let re = /(?:\.([^.]+))?$/

  return (
    <div
      className="border-xl flex relative mx-auto mb-4 w-full cursor-pointer rounded-xl bg-adx-white py-6 px-6"
      onClick={showCourseDetail}
    >
      <div className="w-1/3 lg:w-1/4 h-auto place-items-center justify-self-center ">
        {props.item.id === courseID && (
          <div
            className="absolute top-0 left-0 rounded-tl-[12px] rounded-bl-[12px] hidden h-full w-2 lg:block lg:bg-adx-darkGreen"
          />
        )}
        {props.item.course_logo === null || re.exec(props.item.course_logo)[1] === 'pdf' ? (
          <div className="flex h-20 w-20 items-center justify-center rounded-full bg-adx-white text-3xl text-black shadow">
            {props.item.course_title.charAt(0)}
          </div>
        ) : (
          <img
            src={props.item.course_logo}
            alt="course_logo"
            className="h-20 w-20 rounded-full object-cover shadow"
          />
        )}
      </div>

      <div className="w-2/3 lg:w-3/4 flex flex-col lg:flex-row lg:justify-between">
        <div className={props.item?.countdown > 0 ? 'w-full lg:w-3/4' : 'w-full'}>
          <p className="w-5/6 truncate font-semibold capitalize text-adx-darkGreen">
            {props.item.course_title}
          </p>
          <p className="mb-2 w-5/6 truncate text-sm font-semibold">by {props.item.trainer_name}</p>
          <p className="mb-1 w-5/6 truncate text-sm">{props.item.course_setting}</p>
        </div>
        {
          props.item?.countdown > 0 && <div className='w-1/4 flex flex-col justify-center items-start lg:items-end'>
            <StatusChipApplication applicationStatusId={{
              textStatus: props.item?.countdown > 1 ? `${props.item?.countdown} days left` : `1 day left`
            }} />
          </div>
        }
      </div>
    </div>
  )
}

export default CourseCard
